import React from 'react'
import greyMarker from './marker-grey.png'
import Marker from './Marker'
import s from './AddressMarker.less'
import { ADDRESS_BIG_MARKER_HEIGHT, ADDRESS_BIG_MARKER_WIDTH, IMAGE_MARKER } from './MarkerConstants'
import { withMapReady } from '../map.utils'

export default withMapReady(function AddressMarker({ coordinates, onClick }) {
  return (
    <Marker
      coordinates={coordinates}
      src={greyMarker}
      type={IMAGE_MARKER}
      width={ADDRESS_BIG_MARKER_WIDTH}
      height={ADDRESS_BIG_MARKER_HEIGHT}
      onClick={onClick}
      cssClasses={s.addressMarker}
    />
  )
})
